import { render } from "./bill.vue?vue&type=template&id=7bdf51f3&scoped=true"
import script from "./bill.vue?vue&type=script&lang=js"
export * from "./bill.vue?vue&type=script&lang=js"

import "./bill.vue?vue&type=style&index=0&id=7bdf51f3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7bdf51f3"

export default script